const pluginCookiesConsent = {
  handle: 'plugin_cookies_consent',
  settings: {
    copyright: null,
    imprint: null,
    disclaimer: null,
    verticalAlign: 'left',
    horizontalAlign: 'bottom',
    showBackground: false,
  },
};

export default pluginCookiesConsent;
